export class CreateCorporateTirage
{
    montant:number;
    dateTirage:String;
    echeance:number;
    faciliteId:number;
}